<template>
  <md-dialog
    ref="dialog"
    :md-click-outside-to-close="false"
    :md-esc-to-close="true"
    class="microbiology-partial-warning-modal"
  >
    <md-dialog-content>
      <div class="partial-warning">
        <div class="partial-warning__icon">!</div>
        <h3>O Antibiograma a seguir e um RESULTADO PARCIAL</h3>

        <p>
          Temporariamente, resultados de cultura que contenham mais de um microorganismo
          identificado, nao estao devidamente pareados com o antibiograma no laudo
          parcial.
        </p>

        <p>
          Solicitamos que confirme este tipo de resultado junto a area tecnica do
          laboratorio ou consulte o laudo finalizado.
        </p>

        <p>
          Certos da sua compreensao, estamos engajados na rapida implementacao da melhoria
          na navegacao.
        </p>

        <button
          class="btn btn-primary partial-warning__cta"
          @click="$emit('continue')"
        >
          Ver resultado PARCIAL
        </button>
      </div>
    </md-dialog-content>
  </md-dialog>
</template>

<script>
export default {
  name: 'PartialWarningModal',
  methods: {
    open() {
      this.$refs.dialog.open()
    },
    close() {
      this.$refs.dialog.close()
    },
  },
}
</script>

<style lang="scss">
.microbiology-partial-warning-modal .md-dialog {
  width: 680px;
  max-width: calc(100vw - 40px);
  border-radius: 10px;
}

.microbiology-partial-warning-modal .partial-warning {
  padding: 22px 24px 16px;
}

.microbiology-partial-warning-modal .partial-warning__icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #e2a10a;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 22px;
  margin-bottom: 12px;
}

.microbiology-partial-warning-modal .partial-warning h3 {
  font-size: 22px;
  line-height: 1.25;
  color: #222;
  margin: 0 0 18px;
  max-width: 560px;
  font-weight: 700;
}

.microbiology-partial-warning-modal .partial-warning p {
  font-size: 15px;
  color: #333;
  line-height: 1.5;
  margin: 0 0 12px;
  max-width: 560px;
}

.microbiology-partial-warning-modal .partial-warning__cta {
  margin: 18px auto 4px;
  display: block;
  min-width: 250px;
}
</style>
